/**
 * Diagnosis Service
 * Patient diagnosis tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VocabularyElementResponseDto { 
    /**
     * Element identifier
     */
    id: string;
    /**
     * Collection identifier
     */
    collectionId: string;
    /**
     * Unique slug for the vocabulary element
     */
    slug: string;
    /**
     * Display name of the vocabulary element
     */
    display: string;
    /**
     * Description of the vocabulary element
     */
    description?: string;
    /**
     * Status of the vocabulary element
     */
    status: VocabularyElementResponseDto.StatusEnum;
    /**
     * Metadata for the vocabulary element
     */
    metadata?: any;
}
export namespace VocabularyElementResponseDto {
    export type StatusEnum = 'draft' | 'active' | 'inactive';
    export const StatusEnum = {
        Draft: 'draft' as StatusEnum,
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum
    };
}


